import { render, staticRenderFns } from "./VMaskedTextarea.vue?vue&type=template&id=c782c534&"
import script from "./VMaskedTextarea.vue?vue&type=script&lang=js&"
export * from "./VMaskedTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports